const firebaseConfig = {
    apiKey: "AIzaSyBDxIIfVnKL9KwwCVlsRmYf2BX8KJOOu7E",
    authDomain: "project-glossary-dev.firebaseapp.com",
    databaseURL: "https://project-glossary-dev.firebaseio.com",
    projectId: "project-glossary-dev",
    storageBucket: "project-glossary-dev.appspot.com",
    messagingSenderId: "865775499981",
    appId: "1:865775499981:web:4e71c78d961a3a77adc784"
};

export default firebaseConfig;